export const setProfessionalCaptation = ({ commit }, payload) => {
  commit('SET_PROFESSIONAL_CAPTATION', payload)
}
export const setProfessionalCaptationLoading = ({ commit }, payload) => {
  commit('SET_PROFESSIONAL_CAPTATION_LOADING', payload)
}

export const setProfessionalSegmentations = ({ commit }, payload) => {
  commit('SET_PROFESSIONAL_SEGMENTATIONS', payload)
}
export const setProfessionalSegmentationsLoading = ({ commit }, payload) => {
  commit('SET_PROFESSIONAL_SEGMENTATIONS_LOADING', payload)
}

export const setProfessionalSegmentationsHistorical = ({ commit }, payload) => {
  commit('SET_PROFESSIONALSEGMENTATIONSHISTORICAL', payload)
}
export const addProfessionalSegmentationsHistorical = ({ commit }, payload) => {
  commit('ADD_PROFESSIONALSEGMENTATIONSHISTORICAL', payload)
}
export const setProfessionalSegmentationsHistoricalLoading = (
  { commit },
  payload
) => {
  commit('SET_PROFESSIONALSEGMENTATIONSHISTORICAL_LOADING', payload)
}

export const setValuationHolding = ({ commit }, payload) => {
  commit('SET_VALUATION_HOLDING', payload)
}
export const setValuationHoldingLoading = ({ commit }, payload) => {
  commit('SET_VALUATION_HOLDING_LOADING', payload)
}

export const setPJPartnership = ({ commit }, payload) => {
  commit('SET_PJ_PARTNERSHIP', payload)
}
export const setPJPartnershipLoading = ({ commit }, payload) => {
  commit('SET_PJ_PARTNERSHIP_LOADING', payload)
}

export const setCustomers = ({ commit }, payload) => {
  commit('SET_CUSTOMERS', payload)
}
export const addCustomers = ({ commit }, payload) => {
  commit('ADD_CUSTOMERS', payload)
}
export const setCustomersLoading = ({ commit }, payload) => {
  commit('SET_CUSTOMERS_LOADING', payload)
}
export const setFamilyGroup = ({ commit }, payload) => {
  commit('SET_FAMILY_GROUP', payload)
}
export const addFamilyGroup = ({ commit }, payload) => {
  commit('ADD_FAMILY_GROUP', payload)
}
export const setFamilyGroupLoading = ({ commit }, payload) => {
  commit('SET_FAMILY_GROUP_LOADING', payload)
}

export const setCustomersPartners = ({ commit }, payload) => {
  commit('SET_CUSTOMERS_PARTNERS', payload)
}
export const addCustomersPartners = ({ commit }, payload) => {
  commit('ADD_CUSTOMERS_PARTNERS', payload)
}
export const setCustomersPartnersLoading = ({ commit }, payload) => {
  commit('SET_CUSTOMERS_PARTNERS_LOADING', payload)
}

export const setCalculator = ({ commit }, payload) => {
  commit('SET_CALCULATOR', payload)
}
export const addCalculator = ({ commit }, payload) => {
  commit('ADD_CALCULATOR', payload)
}
export const setCalculatorLoading = ({ commit }, payload) => {
  commit('SET_CALCULATOR_LOADING', payload)
}

export const setCaptable = ({ commit }, payload) => {
  commit('SET_CAPTABLE', payload)
}
export const addCaptable = ({ commit }, payload) => {
  commit('ADD_CAPTABLE', payload)
}
export const setCaptableLoading = ({ commit }, payload) => {
  commit('SET_CAPTABLE_LOADING', payload)
}
export const setCaptableFees = ({ commit }, payload) => {
  commit('SET_CAPTABLE_FEES', payload)
}
export const addCaptableFees = ({ commit }, payload) => {
  commit('ADD_CAPTABLE_FEES', payload)
}
export const setCaptableFeesLoading = ({ commit }, payload) => {
  commit('SET_CAPTABLE_FEES_LOADING', payload)
}
export const setControlPartnership = ({ commit }, payload) => {
  commit('SET_CONTROL_PARTNERSHIP', payload)
}
export const addControlPartnership = ({ commit }, payload) => {
  commit('ADD_CONTROL_PARTNERSHIP', payload)
}
export const setControlPartnershipLoading = ({ commit }, payload) => {
  commit('SET_CONTROL_PARTNERSHIP_LOADING', payload)
}

export const setControlSummary = ({ commit }, payload) => {
  commit('SET_CONTROL_SUMMARY', payload)
}
export const addControlSummary = ({ commit }, payload) => {
  commit('ADD_CONTROL_SUMMARY', payload)
}
export const setControlSummaryLoading = ({ commit }, payload) => {
  commit('SET_CONTROL_SUMMARY_LOADING', payload)
}
export const setRankingCaptacao = ({ commit }, payload) => {
  commit('SET_RANKING_CAPTACAO', payload)
}
export const addRankingCaptacao = ({ commit }, payload) => {
  commit('ADD_RANKING_CAPTACAO', payload)
}
export const setRankingCaptacaoLoading = ({ commit }, payload) => {
  commit('SET_RANKING_CAPTACAO_LOADING', payload)
}

export const setMixComments = ({ commit }, payload) => {
  commit('SET_MIX_COMMENTS', payload)
}
export const addMixComments = ({ commit }, payload) => {
  commit('ADD_MIX_COMMENTS', payload)
}
export const setMixCommentsLoading = ({ commit }, payload) => {
  commit('SET_MIX_COMMENTS_LOADING', payload)
}

export const setOrcadoRealizado = ({ commit }, payload) => {
  commit('SET_ORCADO_REALIZADO', payload)
}
export const addOrcadoRealizado = ({ commit }, payload) => {
  commit('ADD_ORCADO_REALIZADO', payload)
}
export const setOrcadoRealizadoLoading = ({ commit }, payload) => {
  commit('SET_ORCADO_REALIZADO_LOADING', payload)
}
